import { SignedParams } from '@/system-modules/auth/v1/api/v1/auth/Register/Dto/SignedParams'

/** Регистрация: подписанный вызов и два PIN учётной записи */
export class RegisterParams extends SignedParams {
  pin: string
  resetPin: string

  constructor({ publicKey, challenge, signature, pin, resetPin, workspace }: {
    publicKey: string, challenge: string, signature: string, pin: string, resetPin: string, workspace?: string
  }) {
    super({ publicKey, challenge, signature, workspace })
    this.pin = pin
    this.resetPin = resetPin
  }
}
